import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { match } from 'ts-pattern';
import { LOGOS } from './logo.constants';
import type { PsUiSize } from '../../types';

export type LogoVariant = 'full' | 'icon' | 'text';
export type LogoColor = 'white' | 'dark';

@Component({
  selector: 'ps-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  public readonly size = input<PsUiSize>('md');
  public readonly variant = input<LogoVariant>('full');
  public readonly color = input<LogoColor>('white');

  protected readonly src = computed<string>(() =>
    match({ variant: this.variant(), color: this.color() })
      .with({ variant: 'icon' }, () => LOGOS.ICON)
      .with({ color: 'dark' }, () => LOGOS.DARK)
      .otherwise(() => LOGOS.WHITE),
  );

  protected readonly sizeClass = computed<string>(
    () => `ps-logo-${this.size()}`,
  );
  protected readonly variantClass = computed<string>(
    () => `ps-logo-${this.variant()}`,
  );
}
